module.exports = __webpack_public_path__ + "img/banner9.0b849fd0.jpg";